import React, { useEffect } from "react";
import { Card, CardContent } from "./ui/card";
import { ArrowRight } from "lucide-react";
import analyticsService from "../lib/AnalyticsService";
import { useInteractionTracking } from "../hooks/useAnalytics";

const OfferDeclineChoiceScreen = ({ onOptionSelected }) => {
  const { trackButtonClick } = useInteractionTracking();

  useEffect(() => {
    analyticsService.trackPageView("offer_decline_choice");
  }, []);

  const handleOptionClick = (option) => {
    trackButtonClick("decline-choice-option", {
      step_name: "offer_decline_choice",
      option_selected: option,
    });
    onOptionSelected(option);
  };

  const options = [
    { id: "explore_anyway", label: "Explore anyway" },
    { id: "see_other_offers", label: "See other Ownli offers" },
  ];

  return (
    <div className="space-y-6">
      <div className="text-center space-y-4">
        <h1 className="text-xl font-bold uppercase">No Problem</h1>
        <p className="text-darkGrey">
          We understand. How would you like to proceed?
        </p>
      </div>

      <Card>
        <CardContent className="pt-6 space-y-3">
          {options.map((option) => (
            <button
              key={option.id}
              onClick={() => handleOptionClick(option.id)}
              className="w-full flex items-center justify-between p-4 rounded-lg border border-gray-200 hover:border-purple-300 hover:bg-purple-50 transition-colors"
            >
              <span className="font-medium text-gray-900">{option.label}</span>
              <ArrowRight className="w-4 h-4 text-gray-400" />
            </button>
          ))}
        </CardContent>
      </Card>
    </div>
  );
};

export default OfferDeclineChoiceScreen;
